export default __webpack_public_path__ + "static/media/chairman.35bfcbfd.jpg";